import React from 'react'
/* import { makeStyles } from '@material-ui/core/styles' */
import { Grid, Paper } from '@material-ui/core'
/* import clsx from 'clsx' */
import LoginForm from '../Components/LoginForm'

/* const useStyle = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 300,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: '1.5rem',
  },
  pos: {
    marginBottom: 12,
  },
})) */

export default function LoginPage(props) {
  if (localStorage.getItem('user') === undefined) {
    localStorage.clear()
  }
  return (
    <Grid
      container
      spacing={0}
      direction='column'
      alignItems='center'
      justify='center'
      style={{ minHeight: '100vh' }}
    >
      <Grid item xs={12}>
        <Paper elevation={4} style={{ paddingBottom: 40 }}>
          <LoginForm setUser={props.setUser}></LoginForm>
        </Paper>
      </Grid>
    </Grid>
  )
}
